import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastNotificationsService } from '@app/shared/services/toast-notifications/toast-notifications.service';

@Component({
  standalone: false,
  selector: 'hospitable-statements-transaction-add',
  templateUrl: './statements-transaction-add.component.html',
  styleUrls: [],
})
export class StatementsTransactionAddComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toast: ToastNotificationsService
  ) {}

  ngOnInit() {}

  public onSave() {
    this.router.navigate(['../'], { relativeTo: this.route });
    this.toast.success('Transaction created!');
  }
}
